import { call, put, all, takeEvery } from "redux-saga/effects";

import { commentActions } from '../slice/commentSlice'
import { createApi, getAllApi, updateApi, removeApi } from 'services/commentServices'
import ShowToast from "utils/ShowToast";

function* getRattingData(action) {
    try {
        const res = yield call(getAllApi, action.payload.id, action.payload.currentPage, action.payload.sort)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(commentActions.getAllSuccess({ dataComment: response.dataComment, dataReply: response.dataReply, totalPage: response.totalPage, totalComment: response.totalComment }))
            }
            else {
                yield put(commentActions.getAllFailed())
            }
        }
        else {
            yield put(commentActions.getAllFailed())
        }
    } catch (error) {
        yield put(commentActions.getAllFailed())
    }
}


function* createCommentSaga(action) {
    try {
        const res = yield call(createApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(commentActions.createSuccess())
                action.payload.setInputComment && action.payload.setInputComment("")
                ShowToast("success", "Bình luận thành công!")
                action.payload.callBack()
            }
            else {
                yield put(commentActions.createFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(commentActions.createFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(commentActions.createFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}

function* updateCommentSaga(action) {
    try {
        const res = yield call(updateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(commentActions.updateSuccess())
                ShowToast("success", "Cập nhật bình luận thành công!")
                action.payload.callBack()
            }
            else {
                yield put(commentActions.updateFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(commentActions.updateFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(commentActions.updateFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}

function* blockCommentSaga(action) {
    try {
        const res = yield call(updateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(commentActions.updateSuccess())
                ShowToast("success", "Ẩn bình luận thành công!")
                action.payload.callBack()
            }
            else {
                yield put(commentActions.updateFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(commentActions.updateFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(commentActions.updateFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}


function* removeCommentSaga(action) {
    try {
        const res = yield call(removeApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(commentActions.removeSuccess())
                ShowToast("success", "Xóa bình luận thành công!")
                action.payload.callBack()
            }
            else {
                yield put(commentActions.removeFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(commentActions.removeFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(commentActions.removeFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}



export default function* rootSaga() {
    yield all(
        [
            takeEvery(commentActions.create.type, createCommentSaga),
            takeEvery(commentActions.getAll.type, getRattingData),
            takeEvery(commentActions.update.type, updateCommentSaga),
            takeEvery(commentActions.block.type, blockCommentSaga),
            takeEvery(commentActions.remove.type, removeCommentSaga),
        ]
    )
}
